export const orderPaymentType = {
    online: 1,
    cash: 2,
    pin: 3,
    invoice: 9
}

export const orderPaymentTypeOptions = [
    { value: 1, label: "Online" },
    { value: 2, label: "Cash" },
    { value: 3, label: "Pin" },
    { value: 9, label: "Invoice" },
];

export const getOrderPaymentType = (paymentType: number) => {
    return paymentType == 1 && 'Online'
        || paymentType == 2 && 'Cash'
        || paymentType == 3 && 'Pin'
        || paymentType == 9 && 'Invoice'
        || '';
}